import Vue from 'vue';
import Router from 'vue-router';
import { toast } from '@mx/vix';
// import { initTransPage } from '../common/transPage';
// import { bridge } from '../common/bridge';

import Home from '@/views/home';

import support from './support'
import service from './service';
import notice from './notice';
import console from './console'

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Home,
      meta: {
        title: '美团地图'
      }
    },
    support,
    service,
    notice,
    console
  ]
});

// EH TransPage
// initTransPage(router);

router.beforeEach(async(to, from, next) => {
  // console.log(to);
  if (to.path.includes('console')) {
    await router.app.$options.store.dispatch('user/getUserInfo')
    next()
  }
  next();
});
router.beforeResolve((to, from, next) => {
  toast.hide();
  next();
});
router.afterEach((to, from) => {
  if (to.meta.title) {
    // bridge.setTitle(to.meta.title);
  }
  window.scrollTo(0, 0);
});

export default router;
